export default __webpack_public_path__ + "static/media/IMG_2125.64cb1e68.jpg";